import React from "react";
import { Dialog, DialogContent, Typography, DialogActions, Button, CircularProgress } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, body, onClose, onConfirm, loading }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}>
      <DialogContent sx={{ p: 3 }}>
        <Typography sx={{ fontSize: 24, mb: 2 }}>{title}</Typography>
        {typeof body === "string" ? <Typography>{body}</Typography> : body}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={(theme: any) => ({ color: theme.palette.text.primary })}>
          Cancel
        </Button>
        <Button onClick={onConfirm}>
          {loading ? <CircularProgress size={16} /> : null}
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
